// src/utils/storageUtils.js

import api from "../api/ApiService";

/** ----- SESSION STORAGE FUNCTIONS ----- **/

export const setSessionItem = (key, value) => {
  try {
    const jsonValue = JSON.stringify(value);
    sessionStorage.setItem(key, jsonValue);
  } catch (error) {
    console.error(`Error setting sessionStorage item: ${key}`, error);
  }
};

export const getSessionItem = (key) => {
  try {
    const item = sessionStorage.getItem(key);
    return item !== null ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error getting sessionStorage item: ${key}`, error);
    return null;
  }
};

export const removeSessionItem = (key) => {
  sessionStorage.removeItem(key);
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

/** ----- LOCAL STORAGE FUNCTIONS ----- **/

export const setLocalItem = (key, value) => {
  try {
    const jsonValue = JSON.stringify(value);
    localStorage.setItem(key, jsonValue);
  } catch (error) {
    console.error(`Error setting localStorage item: ${key}`, error);
  }
};

export const getLocalItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item !== null ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error getting localStorage item: ${key}`, error);
    return null;
  }
};

export const removeLocalItem = (key) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

/** ----- COMMON GET/SET FUNCTIONS ----- **/

/**
 * Always stores to both localStorage and sessionStorage
 */
export const setStoredItem = (key, value) => {
  setLocalItem(key, value);
  setSessionItem(key, value);
};

/**
 * Gets from localStorage first, then sessionStorage if not found
 */
export const getStoredItem = (key) => {
  const local = getLocalItem(key);
  if (local !== null && local !== undefined) return local;

  return getSessionItem(key);
};

/**
 * Removes key from both storages
 */
export const removeStoredItem = (key) => {
  removeLocalItem(key);
  removeSessionItem(key);
};

/**
 * Clears both localStorage and sessionStorage
 */
export const clearAllStorage = async () => {
  try {
    await api.post("/logout");
  } catch (e) {
  }
  clearLocalStorage();
  clearSessionStorage();
};
